module.exports = __webpack_public_path__ + "img/product-8.826dd1e4.jpg";